import moment from 'moment';
export const RANGE = {
  Today: [moment().set({ hour: 0, minute: 0, second: 0, millisecond: 1 }), moment().set({ hour: 23, minute: 59, second: 59, millisecond: 59 })],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  Yesterday: [moment().subtract(1, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 1 }), moment().subtract(1, 'days').set({ hour: 23, minute: 59, second: 59, millisecond: 59 })],
  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  'This Year': [moment().startOf('year'), moment().endOf('year')]
};
